import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'

import { PlayerListenerComponentDirective } from '../../../base-component/player-listener.component'
import { SellerOfTheDay } from '../../../domain/SellerOfTheDay'
import { convertITrackToPlayerTrack, ITrack } from '../../../Interface/track'
import { PlayerLogic } from '../../../player/AngPlayer'
import { CartService } from '../../../services/cart.service'
import { ProducerService } from '../../../services/producer.service'
import { SsrService } from '../../../services/ssr.service'

@Component({
  selector: 'bmcore-day-seller-producer',
  templateUrl: './bmcore-day-seller-producer.component.html',
  styleUrls: ['./bmcore-day-seller-producer.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreDaySellerProducerComponent extends PlayerListenerComponentDirective<ITrack> implements OnInit {
  producer: SellerOfTheDay

  constructor(
    private producerService: ProducerService,
    public player: PlayerLogic,
    protected cartService: CartService,
    private ssrService: SsrService
  ) {
    super(player, cartService)
  }

  ngOnInit(): void {
    this.ssrService.wait('bmcore-day-seller-producer: producerService.getDaySeller')
    this.producerService.getDaySeller().subscribe(res => {
      this.ssrService.ready('bmcore-day-seller-producer: producerService.getDaySeller')
      this.producer = res
    })
  }

  setPlaylist() {
    this.player.setPlayList(this.producer.beats.map(convertITrackToPlayerTrack))
  }
}
